import type { FC } from "react";

import style from "./Stack.module.css";

interface SpacerProps {
  fixedWidth?: number;
  minWidth?: number;
}

export const Spacer: FC<SpacerProps> = ({ fixedWidth, minWidth }) => {
  return (
    <div
      data-testid="spacer"
      className={typeof fixedWidth === "number" ? style.fixedSpacer : style.spacer}
      style={
        typeof fixedWidth === "number" || typeof minWidth === "number"
          ? { flexBasis: `${fixedWidth}px`, minWidth: `${minWidth}px` }
          : undefined
      }
    />
  );
};
